module.exports = __webpack_public_path__ + "static/media/facility-house-icon.9a73af7a.svg";